import { render } from "./Loader.vue?vue&type=template&id=cb97d868"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=cb97d868&lang=stylus"
script.render = render

export default script